import {Injectable} from '@angular/core';
import {MvsCrudService} from "../../../../core/shared/service/crud/mvs-crud.service";
import {HttpClient} from "@angular/common/http";
import {MvsApiCrudOnlyReadService} from "../../../../core/shared/service/api/mvs-api-crud-only-read.service";

@Injectable({
  providedIn: 'root'
})
export class TicketStatusService extends MvsApiCrudOnlyReadService{

  constructor(protected http: HttpClient) {
    super(http, MvsCrudService.baseUrl + '/tm/ticketStatuss');
  }

}

